import $http from "@/plugins/axios"

export default {
    state: {
        listDepartments: [],
    },
    getters: {
        listDepartments: state => state.listDepartments
    },
    actions: {
        async getListDepartments({ commit }, path) {
            const response = await $http.get(path)
            commit("SET_ITEMS", response.data)
        },
    },
    mutations: {
        SET_ITEMS(state, data) {
            state.listDepartments = data
        }
    }
}